import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { useInscriptionPreload } from '@/hooks'

export function RootLayout(): JSX.Element {
    // Solo captura parámetros, no hace precarga hasta que el usuario esté autenticado
    const { hasPreloadData } = useInscriptionPreload()

    useEffect(() => {}, [hasPreloadData])

    return (
        <div className="min-h-screen w-full font-sans">
            <Outlet />
        </div>
    )
}
